<div class="EMDM_Footer">
   <p > Page loaded:  {{time}} UTC (Server Time) [Note: Page is not refreshed after Warning Message]<br/> Session Timeout is: 75 mins; Warning will be issued after 60 mins (15 mins before Timeout).</p>
</div>